import { render, staticRenderFns } from "./ImportProduct.vue?vue&type=template&id=37c497a3&scoped=true"
import script from "./ImportProduct.vue?vue&type=script&lang=js"
export * from "./ImportProduct.vue?vue&type=script&lang=js"
import style0 from "./ImportProduct.vue?vue&type=style&index=0&id=37c497a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c497a3",
  null
  
)

export default component.exports